import { createServer } from 'miragejs';

/**
 * Initialize a Mirage JS server instance. See https://miragejs.com/docs/getting-started/overview/ for more information.
 * @param {object} options - Configuration params for server.
 * @param {boolean} options.shouldUseBackend - Defaults to false. Set as true to allow all requests to use real backend endpoints and not instantiate Mirage server.
 * @return Instance of Mirage JS server. See https://miragejs.com/api/classes/server/
 */
function initMirageServer(options) {
    const { shouldUseBackend, ...rest } = options ?? {};
    const config = { ...rest };

    // Don't initialize the mirage server at all if
    // using real backend
    if (shouldUseBackend) {
        return {};
    }

    const serverInstance = createServer(config);

    return serverInstance;
}

export default initMirageServer;
